import React from 'react';
import { observer } from 'mobx-react';
import FontHeading2 from '../../../../components/fonts/font-heading2/font-heading2';
import FontBody1 from '../../../../components/fonts/font-body1/font-body1';
import Card from '../../../../components/layouts/card/card';
import { FONT_COLOR, FONT_VARIANT } from '../../../../components/fonts/font-props';
import { SelectDropdown } from '../../../../components/inputs/select-dropdown/select-dropdown';
import shipByReturngoPageStore from '../../ship-by-returngo-page-store';
import './supported-carriers-card.scss';
import dashboardStore from '../../../home/stores/dashboard-store';
import CarrierLogo from './carrier-logo/carrier.logo';
import { useResizeDetector } from 'react-resize-detector';
import { isSet } from '../../../../models/model-types-methods';


const Tabs: React.FC = observer(() => {
    const refContainer = React.useRef<HTMLDivElement>(null);
    const refTabs = React.useRef<HTMLDivElement>(null);

    useResizeDetector({
        targetRef: refContainer,
        onResize: ({ width }) => {
            if (isSet(width)) {
                shipByReturngoPageStore.onTabsElementsWidthsChanged({ containerWidth: width, refTabs });
            }
        }
    });

    /** this observer only needed to trigger change, the width of refTabs is not needed */
    useResizeDetector({
        targetRef: refTabs,
        onResize: () => {
            shipByReturngoPageStore.onTabsElementsWidthsChanged({ refTabs });
        }
    });

    const countryOptions = shipByReturngoPageStore.availableCountriesOptions;
    const isSelectorVisisble = countryOptions.length > 0;

    return (
        <div className={`country-selection-panel`}>
            <div ref={refContainer} className={'country-selection-options-container'}>
                <div ref={refTabs} className="country-selection-option-list">
                    {shipByReturngoPageStore.countries.map((topCountry, index) => (
                        <span 
                            className={`country-selection-option ${shipByReturngoPageStore.isCountryTabVisible(index) ? '' : 'hidden'} ${topCountry.code === shipByReturngoPageStore.selectedCountryCode && 'selected'}`} 
                            key={topCountry.code} 
                            onClick={() => shipByReturngoPageStore.setSelectedCountryCode(topCountry.code)}
                        >
                            <FontBody1 color={FONT_COLOR.PRIMARY2}>{topCountry.name}</FontBody1>
                        </span>
                    ))}
                </div>
            </div>
            <div className={`country-selection-dropdown ${isSelectorVisisble ? '' : 'hidden'}`}>
                <SelectDropdown 
                    disabled={!isSelectorVisisble}
                    options={countryOptions} 
                    onChange={(option) => shipByReturngoPageStore.setSelectedCountryCode(option?.value as string)} 
                    value={shipByReturngoPageStore.selectedCountryOption}
                />
            </div>
        </div>
    );
});

const SupportedCarriersCard: React.FC = observer(() => {
    return (
        <Card>
            <div className={`supported-carriers-card`}>
                <FontHeading2 variant={FONT_VARIANT.BOLD}>Supported Carriers & Countries</FontHeading2>
                <FontBody1>
                    Need support for more carriers and countries?{' '}
                    <span className={'supported-carriers-card-open-chat'} onClick={() => dashboardStore.openChat()}>
                        <FontBody1 variant={FONT_VARIANT.UNDER_LINE} color={FONT_COLOR.ACCENT1}>Let us know</FontBody1>
                    </span>
                </FontBody1>
                <div className={'available-carriers-by-countries'}>

                    <Tabs />

                    <div className={'available-carriers-list'}>
                        {shipByReturngoPageStore.getAvailableCarriers().map(carrier => (
                            <div key={carrier.carrierName} className={'available-carrier-item'}>
                                <CarrierLogo carrierCode={shipByReturngoPageStore.getBaseCarrierCode(carrier.carrierCode)} carrierName={carrier.carrierName} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Card>
    );
});

export default SupportedCarriersCard; 